module.exports = __webpack_public_path__ + "static/media/glass2.774532cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass2.png
// module id = 727
// module chunks = 0